module.exports = __webpack_public_path__ + "static/slide-3_website_en-bfc32edaafb7c6f957618966f3a8a3ce.jpg";